<template>
  <div class="error-page">
    <div class="container">
      <img src="@/assets/images/logo-heppi.png" srcset="@/assets/images/logo-heppi@2x.png 2x" height="40px">
      <h2 class="text-primary py-1">Sevidor Indisponível</h2>
      <p>Nosso site está temporariamente fora do ar. Aguarde alguns instantes e tente novamente.</p>
      <p>Caso continue sem acessar, entre em contato com o nosso suporte:</p>
      <div class="text-center">
        <template v-for="(contact, index) in contacts">
          <a class="button button-primary ma-1" :key="index" :href="contactLink(contact.type, contact.contact)" target="_blank" rel="nofollow">
            <img v-if="contact.type === 'Whatsapp'" :key="index" src="@/assets/images/whatsapp_negative.png" srcset="@/assets/images/whatsapp_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'Telefone'" :key="index" src="@/assets/images/phone_negative.png" srcset="@/assets/images/phone_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'E-mail'" :key="index" src="@/assets/images/email_negative.png" srcset="@/assets/images/email_negative@2x.png 2x" />
            {{ contactLinkContent(contact.type) }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '500',
  data () {
    return {
      contacts: [
        {
          type: 'Whatsapp',
          contact: '(81) 9 8181.2327'
        },
        {
          type: 'E-mail',
          contact: 'fala@heppi.com.br'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['whatsappLink'])
  },
  methods: {
    numberPhone (phone) {
      return phone.replace(/[)(-. ]/g, '')
    },
    contactLink (type, title) {
      switch (type) {
        case 'E-mail':
          return 'mailto:' + title
        case 'Whatsapp':
          return this.whatsappLink
      }
    },
    contactLinkContent (type) {
      switch (type) {
        case 'E-mail':
          return 'Envia um e-mail'
        case 'Whatsapp':
          return 'Fala no Whatsapp'
      }
    }
  }
}
</script>
